import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react";
import classNames from "classnames";
import { useOnScreen, useStores } from "hooks";
import { ROUTES_PATHS } from 'const';

const Basket = observer((props) => {
  const { isHeader } = props;
  const [isLoadedCount, setIsLoadedCount] = useState(false);
  const { cartStore } = useStores();

  const { totalItems, getCartItems } = cartStore;


  const ref = useRef(null);
  const isVisible = useOnScreen(ref);

  useEffect(() => {
    setIsLoadedCount(false);
    getCartItems()
      .then(() => setIsLoadedCount(true))
  }, []);

  return (
    <Link to={ROUTES_PATHS.CART} className='basket-container' ref={ref}>
      <div className={classNames("basket", { "basket-fixed": !isVisible && isHeader })}>
        {isLoadedCount && <div className='basket-counter'>{totalItems}</div>}
        <span  className='basket-inner'/>
      </div>
    </Link>
  );
})

export default Basket
